module.exports = __webpack_public_path__ + "img/ptjs.459c1830.png";